define('common/formUtils',[
],
    function () {

        // Clears and deactivates all invalid feedback text on form fields
        function clearInvalidFeedback(formId) {
            if (!formId.startsWith("#")) formId = "#" + formId;
            $(formId + " .is-invalid").removeClass("is-invalid");
            $(formId + " .invalid-feedback").empty();
        }

        // Fills in and activates invalid feedback text on form fields
        function displayInvalidFeedback(invalidFields, formId) {
            if (!formId.startsWith("#")) formId = "#" + formId;
            if (invalidFields) {
                invalidFields.forEach(function (fieldMessage) {
                    var field = $(formId + " [name='" + fieldMessage.FieldName + "']");
                    field.addClass("is-invalid");
                    field.siblings(".invalid-feedback").append(fieldMessage.MessageText);
                });
            }
        }

        // Collects the data from all form fields and returns them as object,
        // using "name" attribute values from form fields as object property names.
        function collectFormData(formId) {
            if (!formId.startsWith("#")) formId = "#" + formId;
            // the serializeArray() jQuery method doesn't take the values from disabled fields, so first I'll
            // temporarily enable all disabled fields, and then disable them again
            var disabledFields = $(formId).find(":input:disabled").prop("disabled", false);
            var serializedData = $(formId).serializeArray();
            disabledFields.prop("disabled", true);
            var formData = {};
            serializedData.forEach(function (data) {
                formData[data.name] = data.value;
            });
            // serializeArray does not return anything for unchecked checkboxes, so we'll add them now with value false
            $(formId + " input[type='checkbox']:not(:checked)").each(function (index, element) {
                formData[element.name] = false;
            });
            // serializeArray returns "on" for checked checkboxes, so we'll set them to true now
            $(formId + " input[type='checkbox']:checked").each(function (index, element) {
                formData[element.name] = true;
            });
            return formData;
        }

        // Goes through all input elements on the form and fills them with data from the
        // given object, matching "name" attribute of the input element with object property name.
        function populateFormWithData(formId, data) {
            if (!formId.startsWith("#")) formId = "#" + formId;
            $(formId + " :input").each(function (index, element) {            
                if (element.type === "radio" ||
                    element.type === "checkbox")
                {
                    if (data[element.name] !== undefined)
                        $(element).prop("checked", $(element).val().toString() === data[element.name].toString());
                }
                else if (element.type === "text" ||
                         element.type === "email" ||
                         element.type === "tel" ||
                         element.type === "password" ||
                         element.type === "textarea" ||
                         element.type === "select-one")
                {
                    if (data[element.name] !== undefined)
                        $(element).val(data[element.name]);
                    else
                        $(element).val(null);
                }
            });
        }

        function disableFields(formId) {
            if (!formId.startsWith("#")) formId = "#" + formId;
            $(formId + " :input").prop("disabled", true);
        }

        function enableFields(formId) {
            if (!formId.startsWith("#")) formId = "#" + formId;
            $(formId + " :input").prop("disabled", false);
        }

        function initializeFloatingLabels(formId) {
            if (!formId.startsWith("#")) formId = "#" + formId;
            $(formId + " .floating-label-container").each(function (index, element) {
                var inputElement = $(element).find(":input")[0];
                if (inputElement.value) $(element).addClass("active");
                else $(element).removeClass("active");
            });
        }

        //adds the form token to the object for use with [ValidateAntiforgeryToken] attribute
        function useToken(data) {            
            var token = $('input[name="__RequestVerificationToken"]').val();
            data.__RequestVerificationToken = token;
        }

        // The form token is tied to the user logged in when the page rendered, so a logout or login in another tab
        // invalidates it. Fetches a token for the current user and puts it into every token input on the page (there
        // can be several, and useToken reads the first). Calls done either way - on failure the old token is kept.
        function refreshToken(done) {
            $.ajax({
                type: "GET",
                url: "/customapi/Order/AntiForgeryToken",
                dataType: "html",
                cache: false,
                timeout: 10000,   // callers may be holding something important (e.g. an authorized payment) - don't keep them waiting
                success: function (html) {
                    var token = $("<div>").html(html).find('input[name="__RequestVerificationToken"]').val();
                    if (token) $('input[name="__RequestVerificationToken"]').val(token);
                },
                complete: function () {
                    if (done) done();
                }
            });
        }

        return {
            clearInvalidFeedback: clearInvalidFeedback,
            displayInvalidFeedback: displayInvalidFeedback,
            collectFormData: collectFormData,
            populateFormWithData: populateFormWithData,
            disableFields: disableFields,
            enableFields: enableFields,
            initializeFloatingLabels: initializeFloatingLabels,
            useToken: useToken,
            refreshToken: refreshToken
        };
    });

